import {
  useParams,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "./context/AuthContext";
import { database } from "./firebase";
import { ref, get } from "firebase/database";
import Login from "./pages/login/Login";
import CustomUrlPage from "./pages/list/CustomUrlPage";

function AliasPanelRoute() {
  const { companyId, locationId } = useParams();
  const { currentUser } = useContext(AuthContext);
  const [isValid, setIsValid] = useState(null); // null = loading, true/false = result
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const validateAliasPanel = async () => {
      try {
        const locationRef = ref(database, `locations/${locationId}`);
        const snapshot = await get(locationRef);

        if (snapshot.exists()) {
          const locationData = snapshot.val();
          const isAliasEnabled =
            locationData.watchHealthAccess === true &&
            locationData.companyId === companyId;

          setIsValid(isAliasEnabled);

          // If alias is enabled and no `/login` suffix, redirect to proper URL
          if (
            isAliasEnabled &&
            !location.pathname.endsWith("/:companyId/:locationId/login") &&
            !currentUser
          ) {
            navigate(`/${companyId}/${locationId}/login`, {
              replace: true,
            });
          }
        } else {
          setIsValid(false);
        }
      } catch (error) {
        console.error("Alias panel validation failed:", error);
        setIsValid(false);
      }
    };

    validateAliasPanel();
  }, [companyId, locationId, location.pathname, currentUser]);

  if (isValid === null) return <div>Loading...</div>;
  if (!isValid) return <Navigate to="/:companyId/:locationId/login" />;

  // If no user logged in and URL is valid, show login
  if (!currentUser) return <Login />;

  // If user is logged in, check access
  const isUserAuthorized =
    currentUser.companyId === companyId &&
    currentUser.locationId === locationId;

  if (isUserAuthorized) {
    return <CustomUrlPage />;
  } else {
    return <Navigate to="/:companyId/:locationId/login" />;
  }
}

export default AliasPanelRoute;
